<template>
  <div>
    <div class="flex items-center justify-between">
      <div class="text-left">
        <img class="sm:hidden" alt="Logo SARAH" src="../assets/logos/LogoSARAH_simplificadaCOR_1.png" style="margin-left: -15px;">
        <img alt="Programa de Educação e Prevenção de Acidentes" src="../assets/titulo_sistema.png"
          style="min-width: 150px; max-width: 247px;" @click="$router.push({ name: 'Inicio' })"
        />
      </div>
      <div  class="block md:hidden" style="align-self: flex-start;" @click="mobileMenu = !mobileMenu">
        <font-awesome-icon size="3x" :icon="['fa', 'bars']" v-if="!mobileMenu" />
        <font-awesome-icon size="3x" :icon="['fa', 'xmark']" v-else />
      </div>
      <ul class="hidden md:flex md:flex-grow justify-end" style="font-weight: 500;">
        <li v-for="(item, idx) in menu" v-bind:key="idx">
          <router-link :class="{ selected: isSelected(item.name) }" class="menu-item" :to="{ name: item.name }">{{ item.desc }}</router-link>
        </li>
      </ul>
      <img class="pl-6 hidden md:block" alt="Logo SARAH" src="../assets/logos/LogoSARAH_simplificadaCOR_1.png" @click="$router.push({ name: 'Inicio' })">
    </div>
    <ul class="mobile-menu" :class="{ 'hidden': !mobileMenu }">
      <li v-for="(item, idx) in menu" v-bind:key="idx">
        <router-link :class="{ selected: isSelected(item.name) }" class="menu-item" :to="{ name: item.name }" @click="mobileMenu = false">{{ item.desc }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {
      menu: [
        { name: 'Inicio', desc: 'Início' },
        { name: 'Conteudos', desc: 'Conteúdos' },
        { name: 'Sobre', desc: 'Sobre' },
        { name: 'Galeria', desc: 'Galeria' },
        { name: 'Contato', desc: 'Contato' },
      ],
      mobileMenu: false
    }
  },
  methods: {
    isSelected(routeName) {
      return this.$route.name === routeName
    }
  }
}
</script>

<style lang="postcss" scoped>
ul li {
    list-style-type: none;
}

.menu-item {
  @apply no-underline text-black py-3 px-6;
}

.menu-item-divider {
  border-right: 1px solid black;
}

.selected {
  border-bottom: 2px solid orange
}

.mobile-menu {
  background-color: white;
  font-weight: 500;
  width: 100%;
  position: absolute;
  z-index: 10;
  padding: 0;
  margin-top: 10px;
  margin-left: -32px;
}

.mobile-menu li {
  background-color: white;
  padding: 20px
}
</style>